import { Action, createReducer, on } from '@ngrx/store';

import {
  initialState,
  EntityTecnicosState,
  entityTecnicosAdapter
} from './entity-tecnicos.state';
import {
  entityTecnicosLoadFailure,
  entityTecnicosLoadRequest,
  entityTecnicosLoadSuccess
} from './entity-tecnicos.actions';

const reducer = createReducer(
  initialState,
  // load
  on(entityTecnicosLoadRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityTecnicosLoadFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityTecnicosLoadSuccess, (state, { items }) =>
    entityTecnicosAdapter.addMany(items, {
      ...state,
      isLoading: false,
      error: null
    })
  )
);

export function tecnicosReducer(
  state: EntityTecnicosState | undefined,
  action: Action
) {
  return reducer(state, action);
}
